export default __webpack_public_path__ + "static/media/eth.70f61920.svg";